uniform float time;

uniform float progress;
uniform vec3 lightPosition;

uniform int shootTextureIndex;
uniform vec4 shootUVTransform;
uniform float shootTextureWeight;
uniform float shootTextureAlpha;

attribute vec3 origin;
attribute vec3 color;

varying vec2 fragmentUV;
varying vec3 fragmentNormal;

varying float light;
varying float backLight;

varying vec3 fragmentColor;
varying vec3 fragmentPosition;

void main() {

  vec4 instancePosition;
  vec4 instanceOrigin;
  vec4 instanceNormal;

  #ifdef USE_INSTANCING 
  instancePosition = instanceMatrix * vec4(position,1.);
  instanceOrigin = instanceMatrix * vec4(origin,1.);
  instanceNormal = instanceMatrix * vec4(normal,0);
  fragmentColor = instanceColor;
  #else
  instancePosition = vec4(position,1.);
  instanceOrigin = vec4(origin,1);
  instanceNormal = vec4(normal,0);
  fragmentColor = vec3(1,1,1);
  #endif

  float inverseProgress = progress * 1.25 - .25;
  vec3 currentPosition = mix(instanceOrigin.xyz, instancePosition.xyz,
  smoothstep(inverseProgress + .25, inverseProgress, uv.y) * (.75 + (progress*.25)));

  vec4 worldPosition = modelMatrix * instancePosition;
  vec4 worldNormal = modelMatrix * instanceNormal;

  light = (dot(normalize(worldNormal.xyz), normalize( lightPosition)) + 1.) / 2.;
  // light *= .25 + worldPosition.y/56.; // For random view.
  backLight = 1.-light ;

  // int x = shootTextureIndex % 8;
  // int y =  shootTextureIndex / 8;
  // float width = 1./8.;
  // float height = 1./4.;
  // vec4 uvTransform = vec4(float(x) * width, float(y) * height,width ,height);

  fragmentNormal = worldNormal.xyz;
  fragmentUV = uv;
  fragmentUV.y = clamp(fragmentUV.y/ (progress*1.2),0.,1.);
  fragmentUV = (fragmentUV * shootUVTransform.zw) + shootUVTransform.xy;

  fragmentPosition = instancePosition.xyz;

  vec4 modelViewPosition = modelViewMatrix * vec4(currentPosition, 1.0);
  gl_Position = projectionMatrix * modelViewPosition;
}